import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';

import { IconComponent as Icon } from 'components/icon';
import { CardBackgroundComponent as Card } from 'components/cards';

import telephoneIcon from 'static/icons/svg/phone-call-button.svg';
import emailIcon from 'static/icons/svg/gmail-logo.svg';
import facebookIcon from 'static/icons/svg/facebook-logo.svg';
import twitterIcon from 'static/icons/svg/twitter-logo.svg';
import instagramIcon from 'static/icons/svg/instagram-logo.svg';
import blogIcon from 'static/icons/svg/blogger-logo.svg';
import defaultIcon from 'static/icons/svg/link-button.svg';

const styles = require('./contact-card-component.styles.scss');

const ICONS = {
  tel: telephoneIcon,
  email: emailIcon,
  facebook: facebookIcon,
  twitter: twitterIcon,
  instagram: instagramIcon,
  blog: blogIcon,
}

function getIcon(type) {
  const icon = ICONS[type];
  return icon || defaultIcon;
}

export const ContactCardComponent = ({ tel, email, links, className }) => (
  <Card className={classnames(styles.ContactCard, className)}>
    <a className={styles.ContactCardRowPersistent} href={`tel:${tel}`}>
      <Icon className={styles.ContactIconPersistent} src={getIcon('tel')} />
      <span className={styles.ContactRowTextPersistent}>{ tel }</span>
    </a>
    <a className={styles.ContactCardRowPersistent} href={`mailto:${email}`}>
      <Icon className={styles.ContactIconPersistent} src={getIcon('email')} />
      <span className={styles.ContactRowTextPersistent}>{ email }</span>
    </a>
    <div className={styles.LinkContainer}>
    {
      Object.keys(links).map((type, idx) => (
        <a className={styles.ContactCardRow} target='_blank' href={links[type]} key={idx}>
          <Icon className={styles.ContactIcon} src={getIcon(type)} />
          <span className={styles.ContactRowText}>{ links[type] }</span>
        </a>
      ))
    }
    </div>
  </Card>
);

ContactCardComponent.propTypes = {
  tel: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  links: PropTypes.shape({
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    blog: PropTypes.string,
  }),
  className: PropTypes.string,
}

ContactCardComponent.defaultProps = {
  className: '',
  links: {},
}



// WEBPACK FOOTER //
// ./src/components/cards/contact/contact-card.component.jsx